import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import './table__body.scss';

const TableBody = (props) => {
    const { children, mix } = props;

    return <div className={cx('table__body', mix)}>{children}</div>;
};

TableBody.propTypes = {
    children: PropTypes.node,
    mix: PropTypes.string,
};

export default TableBody;
